<template>
	<section :class="{animate: animateArrow}" ref="header">
		<header>
			<img src="../assets/images/logo-pow.png" alt="Prince of Wales Hospital Foundation" class="logo-pow" />
			<img src="../assets/images/logo-charity.png" alt="Registered Charity" class="logo-charity" />
		</header>
		<h1><span><strong>Wall</strong> of<br> <strong>Giving</strong></span></h1>
		<h2>A moment out of your day, can make someone else’s</h2>
		<p>A smile, a thank you, a warm embrace&hellip; the smallest acts can often be the most powerful. Join the movement and show your support and gratitude on the Wall of Giving!</p>
	</section>
</template>

<script>
require('waypoints/lib/noframework.waypoints.min.js');

export default {
	data () {
		return {
			animateArrow: true,
		};
	},
	mounted () {
		const _this = this;
		if (window.Waypoint) {
			// eslint-disable-next-line
			const waypoint = new window.Waypoint({
				element: this.$refs.header,
				handler: function (direction) {
					_this.animateArrow = !_this.animateArrow;
				},
				offset: '-35%',
			});
		}
	},
};
</script>

<style lang=less scoped>
	@import (reference) '../assets/less/default.less';

	section { border-top: 14px solid @blue; text-align: center;
		@keyframes arrow {
			0% { transform: translateY(-10px); }
			100% { transform: translateY(10px); }
		}
		&:after { position: relative; z-index: 10; content: ""; display: inline-block; width: 0; height: 0; border-style: solid; border-width: 23px 27.5px 0 27.5px; border-color: #4bbecc transparent transparent transparent; }
		&.animate:after { animation: arrow 1s 0s ease-in-out infinite alternate; }
	}

	header {
		img { display: inline-block; margin: 40px 22px; vertical-align: middle; }
	}

	h1 { color: @grey; font-size: 71px; line-height: .9;
		&:before { display: inline-block; content: ""; width: 405px; height: 242px; vertical-align: middle; background: transparent url(../assets/images/logo.svg) 0 0 no-repeat; }
		span { display: inline-block; vertical-align: middle; }
		strong { text-transform: uppercase;
			&:last-of-type { font-size: 78px; }
		}
	}
	h2 { margin: 0 auto 30px; max-width: 500px; color: @blue; font-size: 30px; text-transform: uppercase; }
	p { margin: 0 auto 80px; max-width: 450px; color: @grey; font-size: 18px; }

	@media @tablet {
		section:after { margin: 2rem auto; }
		p { margin-bottom: 0; }
	}

	@media @mobile {
		section:after { border-width: 13px 15px 0 15px; margin-bottom: 2rem; }
		header {
			img { display: inline-block; margin: 20px 10px; vertical-align: middle; }
		}
		h1 { margin: 0 auto; font-size: 35px;
			&:before { .size(140px, 110px); margin-right: 10px; background-size: 130%; }
			strong:last-of-type { font-size: 35px; }
		}
		h2 { max-width: 300px; margin: 20px auto; font-size: 20px; }
		p { max-width: 280px;  margin: 0 auto 20px; }
	}
</style>



// WEBPACK FOOTER //
// src/components/TheHeader.vue